/**
 *  后端字段常量属性
 *  用于判断,等逻辑。
 *  @description 审核字段由于后端不统一,所以不能存放在system中
 */

import { Tag } from 'ant-design-vue/lib'

// 系统模块
export const System = {
  Module: {
    Member: 1, // 用户
    Company: 2, // 企业
    Exhibition: 3, // 展览
    Meeting: 4, // 会议
    Model: 5, // 模型
    Infomation: 6, // 资讯
    Live: 7, // 直播
    Poster: 8, // 海报设计
    HomePage: 9, // 首页
    Product: 10, // 产品
    ThreeDimension: 12, // 3D
    Bidding: 13, // 招标
    Recruit: 21,
    CloudSystem: 206, // 企业云展
    Procurement: 23, // 采购
    Merchants: 24, // 云招商
  },
  TrackModule: {
    CompanyHome: 1, // 企业首页
    CompanyPanorama: 2, // 云上企业
    CompanyVideo: 3, // 企业视频
    CompanyPartner: 4, // 合作伙伴
    CompanyPhoto: 5, // 企业相册
    Employee: 6, // 企业员工
    Honor: 7, // 企业荣誉
    InstitutionalInvestors: 8, // 投资机构
    ForeignInvestment: 9, // 对外投资
    ThreeDimensiona: 10, // 3D企业
    Product: 12, // 展品
    Live: 13, // 直播
    ExhibitionJoin: 14, // 参展的展览
    Exhibition: 15, // 发布的展览
    Meeting: 16, // 发布的会议
    Model: 17, // 展厅模型
    Bidding: 18, // 招标
    Poster: 19, // 海报制作
    CompanyDynamic: 20, // 企业动态
    ContactUs: 21, // 联系我们
    News: 22, // 资讯
  },
  ShareType: {
    ExhibitionInfoOnLineShare: 'exhibitionInfoOnLineShare', // 云上展览
    ExhibitionPicShare: 'exhibitionPicShare', // (shareParam= 会展code)
    ExhibitionInfoOffLineShare: 'exhibitionInfoOffLineShare', // 线下展览
    LiveShare: 'liveShare', // 直播
    LiveRecordShare: 'liveRecordShare', // 直播回放
    ProductShare: 'productShare', // 产品
    ThreeDExhibitionShare: 'threeDExhibitionShare', // 3D云展
    ThreeDProductShare: 'threeDProductShare', // 3D产品
    MeetingShare: 'meetingShare', // 会议
    InformationShare: 'informationShare', // 资讯
    ModelShare: 'modelShare', // 模型
    PostShare: 'postShare', // 海报
    ExhibitionExhibitorShare: 'exhibitionExhibitorShare', // 分享参展商
    BidingShare: 'bidingShare', // 分享招标
    CompanyPanoramaShare: 'companyPanoramaShare', // 企业云展系统-云上企业( shareParam=云上企业主键id)
    CompanyVideoShare: 'companyVideoShare', // 企业云展系统-企业视频(shareParam=会员unicode)
    CompanyPhotoAlbumShare: 'companyPhotoAlbumShare', // 企业云展系统-企业相册(shareParam=会员unicode)
    CompanyHonorShare: 'companyHonorShare', // 企业云展系统-企业荣誉(shareParam=会员unicode)
    CompanyEmployeeShare: 'companyEmployeeShare', // 企业云展系统--企业员工(shareParam=会员unicode)
    CompanyPartnerShare: 'companyPartnerShare', // 企业云展系统-合作伙伴(shareParam=会员unicode)
    CompanyThreeDimensionalShare: 'companyThreeDimensionalShare', // 3D企业(shareParam=会员unicode )
    HomePageShare: 'homePageShare', // 首页(shareParam=会员unicode)
    CompanyDynamicShare: 'companyDynamicShare', // 企业动态(shareParam= 动态id)
    RecruitmentShare: 'recruitmentShare', // 云招聘
    PurchaseShare: 'purchaseShare', // 采购分享（shareParam=采购编码）
    MerchantsShare: 'merchantsShare', // 招商分享（shareParam=招商编码）
    InvitedAwardShare: 'invitedAwardShare',

    MemberCardShare: 'memberCardShare', // 名片
    MemberCardCompanyShare: 'memberCardCompanyShare',
    AIMemberCardShare: 'aiMemberCardShare', // 名片
    AIMemberCardCompanyShare: 'aiMemberCardCompanyShare',
  },
  // 分享微信小程序的路径
  ShareWechatPath: {
    ExhibitionInfoOnLineShare: 'pages/index/onlineExhibit/onLinedetails/index', // 云上展览
    ExhibitionPicShare: 'pages/index/onlineExhibit/onLinedetails/index', // (shareParam= 会展code)
    ExhibitionInfoOffLineShare: 'pages/global/globalDetails/globalDetails', // 线下展览
    LiveShare: 'pages/index/live/liveDetails/liveDetails', // 直播
    LiveRecordShare: 'pages/index/live/liveDetails/liveDetails',
    ProductShare: 'pages/goods/goodsDetail/goodsDetail', // 产品
    ThreeDExhibitionShare: 'threeDExhibitionShare', // 3D云展
    ThreeDProductShare: 'threeDProductShare', // 3D产品
    MeetingShare: 'pages/meeting/meetingDetail/meetingDetail', // 会议
    InformationShare: 'pages/info/infoDetail/infoDetail', // 资讯
    ModelShare: 'pages/model/modelDetails/modelDetails', // 模型
    PostShare: 'postShare', // 海报
    ExhibitionExhibitorShare: 'exhibitionExhibitorShare', // 分享参展商
    BidingShare: 'pages/bidding/biddingDetail/biddingDetail', // 分享招标
    CompanyPanoramaShare: 'pages/yzSystem/yzSystem', // 企业云展系统-企业3D全景( shareParam=企业3D全景主键id)
    CompanyVideoShare: 'pages/yzSystem/yzSystem', // 企业云展系统-企业视频(shareParam=会员unicode)
    CompanyPhotoAlbumShare: 'pages/yzSystem/yzSystem', // 企业云展系统-企业相册(shareParam=会员unicode)
    CompanyHonorShare: 'pages/yzSystem/yzSystem', // 企业云展系统-企业荣誉(shareParam=会员unicode)
    CompanyEmployeeShare: 'pages/yzSystem/yzSystem', // 企业云展系统--企业员工(shareParam=会员unicode)
    CompanyPartnerShare: 'pages/yzSystem/yzSystem', // 企业云展系统-合作伙伴(shareParam=会员unicode)
    CompanyThreeDimensionalShare: 'pages/yzSystem/yzSystem', // 3D企业(shareParam=会员unicode )
    CompanyDynamicShare: 'pages/yzSystem/yzSystem', // 企业动态
    HomePageShare: 'pages/yzSystem/yzSystem', // 首页(shareParam=会员unicode)
    RecruitmentShare: 'pages/cloud/recruitment/detail', // 云招聘,
    PurchaseShare: 'pages/cloud/purchase/detail', // 采购分享
    MerchantsShare: 'pages/cloud/merchants/detail', // 招商分享
    InvitedAwardShare: 'pages/mine/myInvite/getInvite/getInvite',

    MemberCardShare: 'pages/shareCard/shareCard', // 名片
    MemberCardCompanyShare: 'pages/yzSystem/yzSystem', // 企业角色的个人名片
    AiMemberCardShare: 'pages/business/index', // 名片
    AiMemberCardCompanyShare: 'pages/shareCard/shareCard', // 企业角色的个人名片
  },
  Identity: {
    Person: 1,
    Company: 0,
  },
  // 协议字段
  Agreement: {
    agree: 1, // 同意
    reject: -1, // 拒绝
  },
  // 筛选器字段
  Filter: {
    Domestic: '1', // 国内
    Foreign: '2', // 国外
  },
  // 编辑状态
  EditStatus: {
    Add: 1,
    Edit: 0,
  },
  EditStatusName: {
    1: '新增',
    0: '编辑',
  },
  // 增减符号
  DownOrUp: {
    Plus: 1,
    Not: 0,
    Minus: '-1',
  },
  DownOrUpName: {
    1: '+',
    0: '',
    '-1': '-',
  },
  // 绑定字段
  BindStatus: {
    Bind: 1,
    UnBind: '-1',
  },
  BindStatusName: {
    1: '已绑定',
    '-1': '未绑定',
  },
  CustomerBindStatus: {
    Bind: 1,
    UnBind: '-1',
  },
  CustomerBindStatusName: {
    1: '已绑定',
    '-1': '已解绑',
  },
  MemberType: {
    User: 1, // 用户
    Tourist: 2, // 游客
  },
  //   外呼:1-触达有效 2-疑似无效 3-无效号码
  // 短信:1-触达有效 2-疑似无效
  // 邮件:1-触达有效 2-无效邮箱 3-拒收邮件 4-疑似无效邮箱 5-已注销邮箱 6-邮件退回
  TagTypePhone: {
    1: '触达有效',
    2: '疑似无效',
    3: '无效号码',
  },
  TagTypeSms: {
    1: '触达有效',
    2: '疑似无效',
  },
  TagTypeEmail: {
    1: '触达有效',
    2: '无效邮箱',
    3: '拒收邮件',
    4: '疑似无效邮箱',
    5: '已注销邮箱',
    6: '邮件退回',
  },
}
// 子账号模块
export const SubAccount = {
  Status: {
    Normal: 0,
    // 禁用状态8是可以让用户执行启用的
    deactivate: 8,
    Disable: 9,
    PlatformFreeze: 10,
  },
  StatusName: {
    0: '正常',
    8: '禁用',
    9: '锁定',
    10: '平台冻结',
  },
  CreateMode: {
    default: 0,
    Manual: 1,
    AUTO: 2,
  },
  CreateModeName: {
    0: '默认',
    1: '手动添加',
    2: '自动生成',
  },
}
// 订单模块
export const Order = {
  Type: {
    Model: 5, // 模型
    Live: 7, // 直播
    Poster: 8, // 海报
    oldVip: 50, // 会员服务, 原本的50只作为兼容
    Vip: 51,
    SMS: 13,
  },
  // -1: 失败 0-待付款,1-付款成功,2-交易成功, 3:待审核 4:待回调,7-取消,9-过期自动取消
  Status: {
    Fail: -1,
    WaitPay: 0,
    PaySuccess: 1,
    Success: 2,
    WaitAudit: 3,
    WaitCallback: 4, // 3.1版本不返回
    Cancel: 7,
    Expired: 9,
  },
}

// 发票模块
export const Invoice = {
  Type: {
    Electronic: 1, // 电子发票
  },
  // 抬头
  TitleType: {
    Person: 1, // 个人
    Company: 2, // 单位
  },
  // 开票类型
  InvoicingType: {
    TechnicalServices: 302, // 技术服务费
    Vip: 402, // 会员服务
    SMS: 405, // 短信充值服务
  },
  Status: {
    Expired: -2, // 已过期
    Wait: -1, // 未开票
    Doing: 0, // 开票中
    Complete: 1, // 已出票
  },
}
// 角色模块
export const Role = {
  Id: {
    Visitor: 1, // 参观商
    Organizer: 2, // 主办商
    Exhibitor: 3, // 参展商
    Contractors: 4, // 工程商
    Designer: 5, // 设计师
  },
  IdName: {
    1: '参观商',
    2: '主办商',
    3: '参展商',
    4: '工程商',
    5: '设计师',
  },
  // 旧版本的vip等级
  VipLeveL: {
    Normal: -1, // 不是会员
    Vip: 1, // 会员
  },
  //
  AccountLevel: {
    User: 0,
    Master: 1,
    Child: 2,
  },
  AccountLevelName: {
    0: '普通用户',
    1: '主账号',
    2: '子账号',
  },
  Identity: {
    Person: 1, // 个人
    Company: 0, // 企业
  },
}

// 展览模块
export const Exhibition = {
  Type: {
    Online: 0,
    Offline: 1,
  },
  TypeName: {
    0: '云上展览',
    1: '线下展览',
  },
  AuditExhibitorStatus: {
    Pass: 0,
    Doing: 1,
    Reject: 2,
  },
  AuditExhibitorStatusName: {
    0: '已通过',
    1: '待审核',
    2: '已拒绝',
  },
  IsTopSort: {
    IsTop: 1,
    CancelTop: 0,
  },
  IsTopSortName: {
    1: '置顶',
    0: '取消置顶',
  },
}

// 招标模块
export const Bidding = {
  AllStatus: {
    Normal: 1,
    UnShelve: -1,
    AdminUnShelve: -2,
  },
  AllStatusName: {
    1: '正常',
    '-1': '主动下架',
    '-2': '抽审下架',
  },
  Status: {
    Normal: 1,
    UnShelve: -1,
  },
  StatusName: {
    1: '正常',
    '-1': '主动下架',
  },
  AdminStatus: {
    Normal: 1,
    UnShelve: -1,
  },
  AdminStatusName: {
    1: '正常',
    '-1': '抽审下架',
  },
  AuditStatus: {
    Doing: 1,
    Reject: 2,
  },
  AuditStatusName: {
    1: '审核中',
    2: '审核拒绝',
  },
  CostModel: {
    Free: -1,
    Charge: 1,
  },
  CostModelName: {
    '-1': '免费',
    1: '收费',
  },
}
// 直播模块
export const Live = {
  Status: {
    LiveNow: 0,
    Trailer: 1,
    Replay: 2,
    UnShelve: 3,
  },
  StatusName: {
    0: '直播中',
    1: '预告',
    2: '已结束',
    3: '下架',
  },
  AdminStatus: {
    Normal: 1,
    UnShelve: -1,
  },
  AdminStatusName: {
    1: '正常',
    '-1': '中后台下架',
  },
  CostModel: {
    Free: -1,
    Charge: 1,
  },
  CostModelName: {
    '-1': '免费',
    1: '收费',
  },
}

// 名片模块
export const Namecard = {
  Status: {
    LiveNow: 0,
    Trailer: 1,
    Replay: 2,
    UnShelve: 3,
  },
  StatusName: {
    0: '直播中',
    1: '预告',
    2: '已结束',
    3: '下架',
  },
  AdminStatus: {
    Normal: 1,
    UnShelve: -1,
  },
  AdminStatusName: {
    1: '正常',
    '-1': '中后台下架',
  },
  CostModel: {
    Free: -1,
    Charge: 1,
  },
  CostModelName: {
    '-1': '免费',
    1: '收费',
  },
}

// 短信模板模块
export const SmsTemplate = {
  // 发送对象
  dataType: {
    1: '普通',
    2: '云数据库',
    3: '云数据&其他',
  },
  // 任务状态
  status: {
    0: '发送成功',
    1: '已发送',
    2: '已发送',
    // 2: '发送失败',
    3: '待发送',
  },
}

export const VIP = {
  // 全部的会员套餐列表
  MealList: {
    110000: '个人会员套餐-基础版',
    10000: '企业会员套餐-基础版',
    20000: '企业会员套餐-标准版',
    30000: '企业会员套餐-升级版',
    40000: '企业会员套餐-旗舰版',
    50000: '企业会员套餐-尊享版',

    60000: '企业会员套餐-商务版',
    70000: '企业会员套餐-旗舰版',
    80000: '企业会员套餐-元宇宙版',
  },
  MemberMealList: {
    10000: '基础版',
    20000: '标准版',
    30000: '升级版',
    40000: '旗舰版',
    50000: '尊享版',
    60000: '商务版',
    70000: '旗舰版',
    80000: '元宇宙版',
  },
}

// 聊天状态
export const CALLSTATUS = {
  idle: 0, // 闲置
  inviting: 1, // 邀请
  alerting: 2, // callee 被叫
  confirmRing: 3, // caller 主叫
  receivedConfirmRing: 4, // callee
  answerCall: 5, // 接听电话
  receivedAnswerCall: 6, // 收到接听电话
  confirmCallee: 7, // 收到confirmCallee
}

// 对公转账收款账号信息
export const corporateTransferBankInfo = {
  companyName: '广州智会云科技发展有限公司',
  account: '3602115509100290968',
  beneficiaryBank: '工行广州中山大道中支行',
}

// 手机区号
export const phoneAreaCode = [
  {
    english_name: 'Andorra',
    chinese_name: '安道尔',
    country_code: 'AD',
    phone_code: '376',
  },
  {
    english_name: 'United Arab Emirates',
    chinese_name: '阿拉伯联合酋长国',
    country_code: 'AE',
    phone_code: '971',
  },
  {
    english_name: 'Afghanistan',
    chinese_name: '阿富汗',
    country_code: 'AF',
    phone_code: '93',
  },
  {
    english_name: 'Antigua and Barbuda',
    chinese_name: '安提瓜和巴布达',
    country_code: 'AG',
    phone_code: '1268',
  },
  {
    english_name: 'Anguilla',
    chinese_name: '安圭拉',
    country_code: 'AI',
    phone_code: '1264',
  },
  {
    english_name: 'Albania',
    chinese_name: '阿尔巴尼亚',
    country_code: 'AL',
    phone_code: '355',
  },
  {
    english_name: 'Armenia',
    chinese_name: '亚美尼亚',
    country_code: 'AM',
    phone_code: '374',
  },
  {
    english_name: 'Angola',
    chinese_name: '安哥拉',
    country_code: 'AO',
    phone_code: '244',
  },
  {
    english_name: 'Argentina',
    chinese_name: '阿根廷',
    country_code: 'AR',
    phone_code: '54',
  },
  {
    english_name: 'American Samoa',
    chinese_name: '美属萨摩亚',
    country_code: 'AS',
    phone_code: '1684',
  },
  {
    english_name: 'Austria',
    chinese_name: '奥地利',
    country_code: 'AT',
    phone_code: '43',
  },
  {
    english_name: 'Australia',
    chinese_name: '澳大利亚',
    country_code: 'AU',
    phone_code: '61',
  },
  {
    english_name: 'Aruba',
    chinese_name: '阿鲁巴',
    country_code: 'AW',
    phone_code: '297',
  },
  {
    english_name: 'Azerbaijan',
    chinese_name: '阿塞拜疆',
    country_code: 'AZ',
    phone_code: '994',
  },
  {
    english_name: 'Bosniaand Herzegovina',
    chinese_name: '波斯尼亚和黑塞哥维那',
    country_code: 'BA',
    phone_code: '387',
  },
  {
    english_name: 'Barbados',
    chinese_name: '巴巴多斯',
    country_code: 'BB',
    phone_code: '1246',
  },
  {
    english_name: 'Bangladesh',
    chinese_name: '孟加拉国',
    country_code: 'BD',
    phone_code: '880',
  },
  {
    english_name: 'Belgium',
    chinese_name: '比利时',
    country_code: 'BE',
    phone_code: '32',
  },
  {
    english_name: 'Burkina Faso',
    chinese_name: '布基纳法索',
    country_code: 'BF',
    phone_code: '226',
  },
  {
    english_name: 'Bulgaria',
    chinese_name: '保加利亚',
    country_code: 'BG',
    phone_code: '359',
  },
  {
    english_name: 'Bahrain',
    chinese_name: '巴林',
    country_code: 'BH',
    phone_code: '973',
  },
  {
    english_name: 'Burundi',
    chinese_name: '布隆迪',
    country_code: 'BI',
    phone_code: '257',
  },
  {
    english_name: 'Benin',
    chinese_name: '贝宁',
    country_code: 'BJ',
    phone_code: '229',
  },
  {
    english_name: 'Bermuda',
    chinese_name: '百慕大群岛',
    country_code: 'BM',
    phone_code: '1441',
  },
  {
    english_name: 'Brunei',
    chinese_name: '文莱',
    country_code: 'BN',
    phone_code: '673',
  },
  {
    english_name: 'Bolivia',
    chinese_name: '玻利维亚',
    country_code: 'BO',
    phone_code: '591',
  },
  {
    english_name: 'Caribisch Nederland',
    chinese_name: '荷兰加勒比',
    country_code: 'BQ',
    phone_code: '599',
  },
  {
    english_name: 'Brazil',
    chinese_name: '巴西',
    country_code: 'BR',
    phone_code: '55',
  },
  {
    english_name: 'Bahamas',
    chinese_name: '巴哈马',
    country_code: 'BS',
    phone_code: '1242',
  },
  {
    english_name: 'Bhutan',
    chinese_name: '不丹',
    country_code: 'BT',
    phone_code: '975',
  },
  {
    english_name: 'Botswana',
    chinese_name: '博茨瓦纳',
    country_code: 'BW',
    phone_code: '267',
  },
  {
    english_name: 'Belarus',
    chinese_name: '白俄罗斯',
    country_code: 'BY',
    phone_code: '375',
  },
  {
    english_name: 'Belize',
    chinese_name: '伯利兹',
    country_code: 'BZ',
    phone_code: '501',
  },
  {
    english_name: 'Democratic Republic of theCongo',
    chinese_name: '刚果民主共和国',
    country_code: 'CD',
    phone_code: '243',
  },
  {
    english_name: 'Central African Republic',
    chinese_name: '中非共和国',
    country_code: 'CF',
    phone_code: '236',
  },
  {
    english_name: 'Republic Of The Congo',
    chinese_name: '刚果共和国',
    country_code: 'CG',
    phone_code: '242',
  },
  {
    english_name: 'Switzerland',
    chinese_name: '瑞士',
    country_code: 'CH',
    phone_code: '41',
  },
  {
    english_name: 'Ivory Coast',
    chinese_name: '象牙海岸',
    country_code: 'CI',
    phone_code: '225',
  },
  {
    english_name: 'Cook Islands',
    chinese_name: '库克群岛',
    country_code: 'CK',
    phone_code: '682',
  },
  {
    english_name: 'Chile',
    chinese_name: '智利',
    country_code: 'CL',
    phone_code: '56',
  },
  {
    english_name: 'Cameroon',
    chinese_name: '喀麦隆',
    country_code: 'CM',
    phone_code: '237',
  },
  {
    english_name: 'China',
    chinese_name: '中国',
    country_code: 'CN',
    phone_code: '86',
  },
  {
    english_name: 'Colombia',
    chinese_name: '哥伦比亚',
    country_code: 'CO',
    phone_code: '57',
  },
  {
    english_name: 'CostaRica',
    chinese_name: '哥斯达黎加',
    country_code: 'CR',
    phone_code: '506',
  },
  {
    english_name: 'Cuba',
    chinese_name: '古巴',
    country_code: 'CU',
    phone_code: '53',
  },
  {
    english_name: 'Cape Verde',
    chinese_name: '开普',
    country_code: 'CV',
    phone_code: '238',
  },
  // {
  //   english_name: 'Curacao',
  //   chinese_name: '库拉索',
  //   country_code: 'CW',
  //   phone_code: '599',
  // },
  {
    english_name: 'Cyprus',
    chinese_name: '塞浦路斯',
    country_code: 'CY',
    phone_code: '357',
  },
  {
    english_name: 'Czech',
    chinese_name: '捷克',
    country_code: 'CZ',
    phone_code: '420',
  },
  {
    english_name: 'Germany',
    chinese_name: '德国',
    country_code: 'DE',
    phone_code: '49',
  },
  {
    english_name: 'Djibouti',
    chinese_name: '吉布提',
    country_code: 'DJ',
    phone_code: '253',
  },
  {
    english_name: 'Denmark',
    chinese_name: '丹麦',
    country_code: 'DK',
    phone_code: '45',
  },
  {
    english_name: 'Dominica',
    chinese_name: '多米尼加',
    country_code: 'DM',
    phone_code: '1767',
  },
  {
    english_name: 'dominican republic',
    chinese_name: '多米尼加共和国',
    country_code: 'DO',
    phone_code: '1809',
  },
  {
    english_name: 'Algeria',
    chinese_name: '阿尔及利亚',
    country_code: 'DZ',
    phone_code: '213',
  },
  {
    english_name: 'Ecuador',
    chinese_name: '厄瓜多尔',
    country_code: 'EC',
    phone_code: '593',
  },
  {
    english_name: 'Estonia',
    chinese_name: '爱沙尼亚',
    country_code: 'EE',
    phone_code: '372',
  },
  {
    english_name: 'Egypt',
    chinese_name: '埃及',
    country_code: 'EG',
    phone_code: '20',
  },
  {
    english_name: 'Eritrea',
    chinese_name: '厄立特里亚',
    country_code: 'ER',
    phone_code: '291',
  },
  {
    english_name: 'Spain',
    chinese_name: '西班牙',
    country_code: 'ES',
    phone_code: '34',
  },
  {
    english_name: 'Ethiopia',
    chinese_name: '埃塞俄比亚',
    country_code: 'ET',
    phone_code: '251',
  },
  {
    english_name: 'Finland',
    chinese_name: '芬兰',
    country_code: 'FI',
    phone_code: '358',
  },
  {
    english_name: 'Fiji',
    chinese_name: '斐济',
    country_code: 'FJ',
    phone_code: '679',
  },
  {
    english_name: 'Micronesia',
    chinese_name: '密克罗尼西亚',
    country_code: 'FM',
    phone_code: '691',
  },
  {
    english_name: 'Faroe Islands',
    chinese_name: '法罗群岛',
    country_code: 'FO',
    phone_code: '298',
  },
  {
    english_name: 'France',
    chinese_name: '法国',
    country_code: 'FR',
    phone_code: '33',
  },
  {
    english_name: 'Gabon',
    chinese_name: '加蓬',
    country_code: 'GA',
    phone_code: '241',
  },
  {
    english_name: 'United Kingdom',
    chinese_name: '英国',
    country_code: 'GB',
    phone_code: '44',
  },
  {
    english_name: 'Grenada',
    chinese_name: '格林纳达',
    country_code: 'GD',
    phone_code: '1473',
  },
  {
    english_name: 'Georgia',
    chinese_name: '格鲁吉亚',
    country_code: 'GE',
    phone_code: '995',
  },
  {
    english_name: 'French Guiana',
    chinese_name: '法属圭亚那',
    country_code: 'GF',
    phone_code: '594',
  },
  {
    english_name: 'Ghana',
    chinese_name: '加纳',
    country_code: 'GH',
    phone_code: '233',
  },
  {
    english_name: 'Gibraltar',
    chinese_name: '直布罗陀',
    country_code: 'GI',
    phone_code: '350',
  },
  {
    english_name: 'Greenland',
    chinese_name: '格陵兰岛',
    country_code: 'GL',
    phone_code: '299',
  },
  {
    english_name: 'Gambia',
    chinese_name: '冈比亚',
    country_code: 'GM',
    phone_code: '220',
  },
  {
    english_name: 'Guinea',
    chinese_name: '几内亚',
    country_code: 'GN',
    phone_code: '224',
  },
  {
    english_name: 'Guadeloupe',
    chinese_name: '瓜德罗普岛',
    country_code: 'GP',
    phone_code: '590',
  },
  {
    english_name: 'Equatorial Guinea',
    chinese_name: '赤道几内亚',
    country_code: 'GQ',
    phone_code: '240',
  },
  {
    english_name: 'Greece',
    chinese_name: '希腊',
    country_code: 'GR',
    phone_code: '30',
  },
  {
    english_name: 'Guatemala',
    chinese_name: '瓜地马拉',
    country_code: 'GT',
    phone_code: '502',
  },
  {
    english_name: 'Guam',
    chinese_name: '关岛',
    country_code: 'GU',
    phone_code: '1671',
  },
  {
    english_name: 'Guinea-Bissau',
    chinese_name: '几内亚比绍共和国',
    country_code: 'GW',
    phone_code: '245',
  },
  {
    english_name: 'Guyana',
    chinese_name: '圭亚那',
    country_code: 'GY',
    phone_code: '592',
  },
  {
    english_name: 'Hong Kong',
    chinese_name: '中国香港',
    country_code: 'HK',
    phone_code: '852',
  },
  {
    english_name: 'Honduras',
    chinese_name: '洪都拉斯',
    country_code: 'HN',
    phone_code: '504',
  },
  {
    english_name: 'Croatia',
    chinese_name: '克罗地亚',
    country_code: 'HR',
    phone_code: '385',
  },
  {
    english_name: 'Haiti',
    chinese_name: '海地',
    country_code: 'HT',
    phone_code: '509',
  },
  {
    english_name: 'Hungary',
    chinese_name: '匈牙利',
    country_code: 'HU',
    phone_code: '36',
  },
  {
    english_name: 'Indonesia',
    chinese_name: '印度尼西亚',
    country_code: 'ID',
    phone_code: '62',
  },
  {
    english_name: 'Ireland',
    chinese_name: '爱尔兰',
    country_code: 'IE',
    phone_code: '353',
  },
  {
    english_name: 'Israel',
    chinese_name: '以色列',
    country_code: 'IL',
    phone_code: '972',
  },
  {
    english_name: 'India',
    chinese_name: '印度',
    country_code: 'IN',
    phone_code: '91',
  },
  {
    english_name: 'Iraq',
    chinese_name: '伊拉克',
    country_code: 'IQ',
    phone_code: '964',
  },
  {
    english_name: 'Iran',
    chinese_name: '伊朗',
    country_code: 'IR',
    phone_code: '98',
  },
  {
    english_name: 'Iceland',
    chinese_name: '冰岛',
    country_code: 'IS',
    phone_code: '354',
  },
  {
    english_name: 'Italy',
    chinese_name: '意大利',
    country_code: 'IT',
    phone_code: '39',
  },
  {
    english_name: 'Jamaica',
    chinese_name: '牙买加',
    country_code: 'JM',
    phone_code: '1876',
  },
  {
    english_name: 'Jordan',
    chinese_name: '约旦',
    country_code: 'JO',
    phone_code: '962',
  },
  {
    english_name: 'Japan',
    chinese_name: '日本',
    country_code: 'JP',
    phone_code: '81',
  },
  {
    english_name: 'Kenya',
    chinese_name: '肯尼亚',
    country_code: 'KE',
    phone_code: '254',
  },
  {
    english_name: 'Kyrgyzstan',
    chinese_name: '吉尔吉斯斯坦',
    country_code: 'KG',
    phone_code: '996',
  },
  {
    english_name: 'Cambodia',
    chinese_name: '柬埔寨',
    country_code: 'KH',
    phone_code: '855',
  },
  {
    english_name: 'Kiribati',
    chinese_name: '基里巴斯',
    country_code: 'KI',
    phone_code: '686',
  },
  {
    english_name: 'Comoros / Mayotte',
    chinese_name: '科摩罗 / 马约特',
    country_code: 'KM / YT',
    phone_code: '269',
  },
  {
    english_name: 'Saint Kitts and Nevis',
    chinese_name: '圣基茨和尼维斯',
    country_code: 'KN',
    phone_code: '1869',
  },
  {
    english_name: 'Korea Democratic Rep.',
    chinese_name: '朝鲜',
    country_code: 'KP',
    phone_code: '850',
  },
  {
    english_name: 'South Korea',
    chinese_name: '韩国',
    country_code: 'KR',
    phone_code: '82',
  },
  {
    english_name: 'Kuwait',
    chinese_name: '科威特',
    country_code: 'KW',
    phone_code: '965',
  },
  {
    english_name: 'Cayman Islands',
    chinese_name: '开曼群岛',
    country_code: 'KY',
    phone_code: '1345',
  },
  {
    english_name: 'Laos',
    chinese_name: '老挝',
    country_code: 'LA',
    phone_code: '856',
  },
  {
    english_name: 'Lebanon',
    chinese_name: '黎巴嫩',
    country_code: 'LB',
    phone_code: '961',
  },
  {
    english_name: 'Saint Lucia',
    chinese_name: '圣露西亚',
    country_code: 'LC',
    phone_code: '1758',
  },
  {
    english_name: 'Liechtenstein',
    chinese_name: '列支敦士登',
    country_code: 'LI',
    phone_code: '423',
  },
  {
    english_name: 'Sri Lanka',
    chinese_name: '斯里兰卡',
    country_code: 'LK',
    phone_code: '94',
  },
  {
    english_name: 'Liberia',
    chinese_name: '利比里亚',
    country_code: 'LR',
    phone_code: '231',
  },
  {
    english_name: 'Lesotho',
    chinese_name: '莱索托',
    country_code: 'LS',
    phone_code: '266',
  },
  {
    english_name: 'Lithuania',
    chinese_name: '立陶宛',
    country_code: 'LT',
    phone_code: '370',
  },
  {
    english_name: 'Luxembourg',
    chinese_name: '卢森堡',
    country_code: 'LU',
    phone_code: '352',
  },
  {
    english_name: 'Latvia',
    chinese_name: '拉脱维亚',
    country_code: 'LV',
    phone_code: '371',
  },
  {
    english_name: 'Libya',
    chinese_name: '利比亚',
    country_code: 'LY',
    phone_code: '218',
  },
  {
    english_name: 'Morocco',
    chinese_name: '摩洛哥',
    country_code: 'MA',
    phone_code: '212',
  },
  {
    english_name: 'Monaco',
    chinese_name: '摩纳哥',
    country_code: 'MC',
    phone_code: '377',
  },
  {
    english_name: 'Moldova',
    chinese_name: '摩尔多瓦',
    country_code: 'MD',
    phone_code: '373',
  },
  {
    english_name: 'Montenegro',
    chinese_name: '黑山',
    country_code: 'ME',
    phone_code: '382',
  },
  {
    english_name: 'Madagascar',
    chinese_name: '马达加斯加',
    country_code: 'MG',
    phone_code: '261',
  },
  {
    english_name: 'Marshall Islands',
    chinese_name: '马绍尔群岛',
    country_code: 'MH',
    phone_code: '692',
  },
  {
    english_name: 'Macedonia',
    chinese_name: '马其顿',
    country_code: 'MK',
    phone_code: '389',
  },
  {
    english_name: 'Mali',
    chinese_name: '马里',
    country_code: 'ML',
    phone_code: '223',
  },
  {
    english_name: 'Myanmar',
    chinese_name: '缅甸',
    country_code: 'MM',
    phone_code: '95',
  },
  {
    english_name: 'Mongolia',
    chinese_name: '蒙古',
    country_code: 'MN',
    phone_code: '976',
  },
  {
    english_name: 'Macau',
    chinese_name: '中国澳门',
    country_code: 'MO',
    phone_code: '853',
  },
  {
    english_name: 'Mauritania',
    chinese_name: '毛里塔尼亚',
    country_code: 'MR',
    phone_code: '222',
  },
  {
    english_name: 'Montserrat',
    chinese_name: '蒙特塞拉特岛',
    country_code: 'MS',
    phone_code: '1664',
  },
  {
    english_name: 'Malta',
    chinese_name: '马耳他',
    country_code: 'MT',
    phone_code: '356',
  },
  {
    english_name: 'Mauritius',
    chinese_name: '毛里求斯',
    country_code: 'MU',
    phone_code: '230',
  },
  {
    english_name: 'Maldives',
    chinese_name: '马尔代夫',
    country_code: 'MV',
    phone_code: '960',
  },
  {
    english_name: 'Malawi',
    chinese_name: '马拉维',
    country_code: 'MW',
    phone_code: '265',
  },
  {
    english_name: 'Mexico',
    chinese_name: '墨西哥',
    country_code: 'MX',
    phone_code: '52',
  },
  {
    english_name: 'Malaysia',
    chinese_name: '马来西亚',
    country_code: 'MY',
    phone_code: '60',
  },
  {
    english_name: 'Mozambique',
    chinese_name: '莫桑比克',
    country_code: 'MZ',
    phone_code: '258',
  },
  {
    english_name: 'Namibia',
    chinese_name: '纳米比亚',
    country_code: 'NA',
    phone_code: '264',
  },
  {
    english_name: 'New Caledonia',
    chinese_name: '新喀里多尼亚',
    country_code: 'NC',
    phone_code: '687',
  },
  {
    english_name: 'Niger',
    chinese_name: '尼日尔',
    country_code: 'NE',
    phone_code: '227',
  },
  {
    english_name: 'Nigeria',
    chinese_name: '尼日利亚',
    country_code: 'NG',
    phone_code: '234',
  },
  {
    english_name: 'Nicaragua',
    chinese_name: '尼加拉瓜',
    country_code: 'NI',
    phone_code: '505',
  },
  {
    english_name: 'Netherlands',
    chinese_name: '荷兰',
    country_code: 'NL',
    phone_code: '31',
  },
  {
    english_name: 'Norway',
    chinese_name: '挪威',
    country_code: 'NO',
    phone_code: '47',
  },
  {
    english_name: 'Nepal',
    chinese_name: '尼泊尔',
    country_code: 'NP',
    phone_code: '977',
  },
  {
    english_name: 'Nauru',
    chinese_name: '拿鲁岛',
    country_code: 'NR',
    phone_code: '674',
  },
  {
    english_name: 'New Zealand',
    chinese_name: '新西兰',
    country_code: 'NZ',
    phone_code: '64',
  },
  {
    english_name: 'Oman',
    chinese_name: '阿曼',
    country_code: 'OM',
    phone_code: '968',
  },
  {
    english_name: 'Panama',
    chinese_name: '巴拿马',
    country_code: 'PA',
    phone_code: '507',
  },
  {
    english_name: 'Peru',
    chinese_name: '秘鲁',
    country_code: 'PE',
    phone_code: '51',
  },
  {
    english_name: 'French Polynesia',
    chinese_name: '法属波利尼西亚',
    country_code: 'PF',
    phone_code: '689',
  },
  {
    english_name: 'Papua New Guinea',
    chinese_name: '巴布亚新几内亚',
    country_code: 'PG',
    phone_code: '675',
  },
  {
    english_name: 'Philippines',
    chinese_name: '菲律宾',
    country_code: 'PH',
    phone_code: '63',
  },
  {
    english_name: 'Pakistan',
    chinese_name: '巴基斯坦',
    country_code: 'PK',
    phone_code: '92',
  },
  {
    english_name: 'Poland',
    chinese_name: '波兰',
    country_code: 'PL',
    phone_code: '48',
  },
  {
    english_name: 'Saint Pierreand Miquelon',
    chinese_name: '圣彼埃尔和密克隆岛',
    country_code: 'PM',
    phone_code: '508',
  },
  {
    english_name: 'Puerto Rico',
    chinese_name: '波多黎各',
    country_code: 'PR',
    phone_code: '1787',
  },
  {
    english_name: 'Portugal',
    chinese_name: '葡萄牙',
    country_code: 'PT',
    phone_code: '351',
  },
  {
    english_name: 'Palau',
    chinese_name: '帕劳',
    country_code: 'PW',
    phone_code: '680',
  },
  {
    english_name: 'Paraguay',
    chinese_name: '巴拉圭',
    country_code: 'PY',
    phone_code: '595',
  },
  {
    english_name: 'Qatar',
    chinese_name: '卡塔尔',
    country_code: 'QA',
    phone_code: '974',
  },
  {
    english_name: 'Réunion Island',
    chinese_name: '留尼汪',
    country_code: 'RE',
    phone_code: '262',
  },
  {
    english_name: 'Romania',
    chinese_name: '罗马尼亚',
    country_code: 'RO',
    phone_code: '40',
  },
  {
    english_name: 'Serbia',
    chinese_name: '塞尔维亚',
    country_code: 'RS',
    phone_code: '381',
  },
  {
    english_name: 'Russia / Kazakhstan',
    chinese_name: '俄罗斯 / 哈萨克斯坦',
    country_code: 'RU / KZ',
    phone_code: '7',
  },
  {
    english_name: 'Rwanda',
    chinese_name: '卢旺达',
    country_code: 'RW',
    phone_code: '250',
  },
  {
    english_name: 'Saudi Arabia',
    chinese_name: '沙特阿拉伯',
    country_code: 'SA',
    phone_code: '966',
  },
  {
    english_name: 'Solomon Islands',
    chinese_name: '所罗门群岛',
    country_code: 'SB',
    phone_code: '677',
  },
  {
    english_name: 'Seychelles',
    chinese_name: '塞舌尔',
    country_code: 'SC',
    phone_code: '248',
  },
  {
    english_name: 'Sudan',
    chinese_name: '苏丹',
    country_code: 'SD',
    phone_code: '249',
  },
  {
    english_name: 'Sweden',
    chinese_name: '瑞典',
    country_code: 'SE',
    phone_code: '46',
  },
  {
    english_name: 'Singapore',
    chinese_name: '新加坡',
    country_code: 'SG',
    phone_code: '65',
  },
  {
    english_name: 'Slovenia',
    chinese_name: '斯洛文尼亚',
    country_code: 'SI',
    phone_code: '386',
  },
  {
    english_name: 'Slovakia',
    chinese_name: '斯洛伐克',
    country_code: 'SK',
    phone_code: '421',
  },
  {
    english_name: 'Sierra Leone',
    chinese_name: '塞拉利昂',
    country_code: 'SL',
    phone_code: '232',
  },
  {
    english_name: 'San Marino',
    chinese_name: '圣马力诺',
    country_code: 'SM',
    phone_code: '378',
  },
  {
    english_name: 'Senegal',
    chinese_name: '塞内加尔',
    country_code: 'SN',
    phone_code: '221',
  },
  {
    english_name: 'Somalia',
    chinese_name: '索马里',
    country_code: 'SO',
    phone_code: '252',
  },
  {
    english_name: 'Suriname',
    chinese_name: '苏里南',
    country_code: 'SR',
    phone_code: '597',
  },
  {
    english_name: 'Sao Tome and Principe',
    chinese_name: '圣多美和普林西比',
    country_code: 'ST',
    phone_code: '239',
  },
  {
    english_name: 'ElSalvador',
    chinese_name: '萨尔瓦多',
    country_code: 'SV',
    phone_code: '503',
  },
  {
    english_name: 'Syria',
    chinese_name: '叙利亚',
    country_code: 'SY',
    phone_code: '963',
  },
  {
    english_name: 'Swaziland',
    chinese_name: '斯威士兰',
    country_code: 'SZ',
    phone_code: '268',
  },
  {
    english_name: 'Turksand Caicos Islands',
    chinese_name: '特克斯和凯科斯群岛',
    country_code: 'TC',
    phone_code: '1649',
  },
  {
    english_name: 'Chad',
    chinese_name: '乍得',
    country_code: 'TD',
    phone_code: '235',
  },
  {
    english_name: 'Togo',
    chinese_name: '多哥',
    country_code: 'TG',
    phone_code: '228',
  },
  {
    english_name: 'Thailand',
    chinese_name: '泰国',
    country_code: 'TH',
    phone_code: '66',
  },
  {
    english_name: 'Tajikistan',
    chinese_name: '塔吉克斯坦',
    country_code: 'TJ',
    phone_code: '992',
  },
  {
    english_name: 'East Timor',
    chinese_name: '东帝汶',
    country_code: 'TL',
    phone_code: '670',
  },
  {
    english_name: 'Turkmenistan',
    chinese_name: '土库曼斯坦',
    country_code: 'TM',
    phone_code: '993',
  },
  {
    english_name: 'Tunisia',
    chinese_name: '突尼斯',
    country_code: 'TN',
    phone_code: '216',
  },
  {
    english_name: 'Tonga',
    chinese_name: '汤加',
    country_code: 'TO',
    phone_code: '676',
  },
  {
    english_name: 'Turkey',
    chinese_name: '土耳其',
    country_code: 'TR',
    phone_code: '90',
  },
  {
    english_name: 'Trinidadand Tobago',
    chinese_name: '特立尼达和多巴哥',
    country_code: 'TT',
    phone_code: '1868',
  },
  {
    english_name: 'Taiwan',
    chinese_name: '中国台湾',
    country_code: 'TW',
    phone_code: '886',
  },
  {
    english_name: 'Tanzania',
    chinese_name: '坦桑尼亚',
    country_code: 'TZ',
    phone_code: '255',
  },
  {
    english_name: 'Ukraine',
    chinese_name: '乌克兰',
    country_code: 'UA',
    phone_code: '380',
  },
  {
    english_name: 'Uganda',
    chinese_name: '乌干达',
    country_code: 'UG',
    phone_code: '256',
  },
  {
    english_name: 'United States / Canada',
    chinese_name: '美国 / 加拿大',
    country_code: 'US / CA',
    phone_code: '1',
  },
  {
    english_name: 'Uruguay',
    chinese_name: '乌拉圭',
    country_code: 'UY',
    phone_code: '598',
  },
  {
    english_name: 'Uzbekistan',
    chinese_name: '乌兹别克斯坦',
    country_code: 'UZ',
    phone_code: '998',
  },
  {
    english_name: 'Saint Vincent and The Grenadines',
    chinese_name: '圣文森特和格林纳丁斯',
    country_code: 'VC',
    phone_code: '1784',
  },
  {
    english_name: 'Venezuela',
    chinese_name: '委内瑞拉',
    country_code: 'VE',
    phone_code: '58',
  },
  {
    english_name: 'VirginIslands,British',
    chinese_name: '英属处女群岛',
    country_code: 'VG',
    phone_code: '1284',
  },
  {
    english_name: 'Vietnam',
    chinese_name: '越南',
    country_code: 'VN',
    phone_code: '84',
  },
  {
    english_name: 'Vanuatu',
    chinese_name: '瓦努阿图',
    country_code: 'VU',
    phone_code: '678',
  },
  {
    english_name: 'Samoa',
    chinese_name: '萨摩亚',
    country_code: 'WS',
    phone_code: '685',
  },
  {
    english_name: 'Yemen',
    chinese_name: '也门',
    country_code: 'YE',
    phone_code: '967',
  },
  {
    english_name: 'South Africa',
    chinese_name: '南非',
    country_code: 'ZA',
    phone_code: '27',
  },
  {
    english_name: 'Zambia',
    chinese_name: '赞比亚',
    country_code: 'ZM',
    phone_code: '260',
  },
  {
    english_name: 'Zimbabwe',
    chinese_name: '津巴布韦',
    country_code: 'ZW',
    phone_code: '263',
  },
]

// 邮件模板模块
export const EmailTemplate = {
  // 任务状态
  status: {
    0: '发送成功',
    1: '发送中',
    2: '发送失败',
    3: '待发送',
    4: '发送停止', // '发送停止',
    5: '暂停发送',
    6: '已取消',
  },
  // 转换小写
  associated_variables: {
    1: '客户名称',
    2: '公司名称',
    3: '职位',
    4: '当前日期',
  },
  // 关联:1-企业云展系统 2-我的名片 3-云产品
  associated_types: {
    1: '企业云展系统',
    2: '我的名片',
    3: '云产品',
  },
  // 退订:1-中文 2-英文 3-日文 4-韩文 5-德语 6-法语 7-意大利语 8-西班牙语
  unsubscribe_languages: {
    1: '中文',
    2: '英文',
    3: '日文',
    4: '韩文',
    5: '德语',
    6: '法语',
    7: '意大利语',
    8: '西班牙语',
  },
}

export const MosaicoEditor = {
  DEFAULT_EMAIL_COMPONENTS: `
    <div class="email-default-wrap">
      <table cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td align="center">
            <table class="email-default-card"  cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td class="email-default-head">邮件标题</td>
              </tr>
              <tr>
                <td class="email-default-body">
                  <h1 class="email-default-title">这里填写邮件标题</h1>
                  <p class="email-default-text">这里填写邮件正文内容，支持继续插入变量、链接、图片和按钮。</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  `,
  DEFAULT_EMAIL_STYLE: `
    .email-default-wrap {
      width: 100%;
      height:100vh;
      background: #f5f7fb;
      padding: 28px 0;
      font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
    }
    .table {
      width: 100%;
      height: 100%;
    }

    .email-default-card {
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
    }

    .email-default-head {
      padding: 20px 32px;
      color: #ffffff;
      font-size: 18px;
      font-weight: 700;
      background: #1f3d68;
    }

    .email-default-body {
      padding: 30px 32px;
    }

    .email-default-title {
      margin: 0 0 12px;
      color: #1d2736;
      font-size: 28px;
      line-height: 1.35;
    }

    .email-default-text {
      margin: 0;
      color: #5f6b7a;
      font-size: 15px;
      line-height: 1.8;
    }
  `,
  GRAPES_ZH_MESSAGES: {
    assetManager: {
      addButton: '添加图片',
      inputPlh: '请输入图片地址',
      modalTitle: '选择图片',
      uploadTitle: '拖拽文件到这里，或点击上传',
    },
    blockManager: {
      labels: {
        sect100: '单列区块',
        sect50: '双列区块',
        sect30: '三列区块',
        sect37: '3:7 区块',
        button: '按钮',
        divider: '分割线',
        text: '文本',
        'text-sect': '标题正文',
        image: '图片',
        quote: '引用',
        link: '链接',
        table: '表格',
        'link-block': '链接区块',
        'grid-items': '网格卡片',
        'list-items': '列表卡片',
      },
    },
    domComponents: {
      names: {
        '': '容器',
        wrapper: '主体',
        text: '文本',
        comment: '注释',
        image: '图片',
        video: '视频',
        label: '标签',
        link: '链接',
        map: '地图',
        tfoot: '表格脚注',
        tbody: '表格主体',
        thead: '表格表头',
        table: '表格',
        row: '表格行',
        cell: '单元格',
      },
    },
    deviceManager: {
      device: '设备',
      devices: {
        desktop: '桌面端',
        tablet: '平板',
        mobileLandscape: '手机横屏',
        mobilePortrait: '手机竖屏',
      },
    },
    panels: {
      buttons: {
        titles: {
          preview: '预览',
          fullscreen: '全屏',
          'sw-visibility': '查看组件',
          'export-template': '查看代码',
          'open-sm': '样式管理',
          'open-tm': '组件设置',
          'open-layers': '图层管理',
          'open-blocks': '区块库',
        },
      },
    },
    selectorManager: {
      label: '类名',
      selected: '已选中',
      emptyState: '- 状态 -',
      states: {
        hover: '悬停',
        active: '点击',
        'nth-of-type(2n)': '奇偶项',
      },
    },
    styleManager: {
      empty: '请先选择元素，再编辑样式',
      layer: '图层',
      fileButton: '图片',
      sectors: {
        general: '常规',
        layout: '布局',
        typography: '排版',
        decorations: '装饰',
        extra: '扩展',
        flex: '弹性布局',
        dimension: '尺寸',
      },
      properties: {
        'text-shadow-h': '水平',
        'text-shadow-v': '垂直',
        'text-shadow-blur': '模糊',
        'text-shadow-color': '颜色',
        'box-shadow-h': '水平',
        'box-shadow-v': '垂直',
        'box-shadow-blur': '模糊',
        'box-shadow-spread': '扩散',
        'box-shadow-color': '颜色',
        'box-shadow-type': '类型',
        'margin-top-sub': '上',
        'margin-right-sub': '右',
        'margin-bottom-sub': '下',
        'margin-left-sub': '左',
        'padding-top-sub': '上',
        'padding-right-sub': '右',
        'padding-bottom-sub': '下',
        'padding-left-sub': '左',
        'border-width-sub': '宽度',
        'border-style-sub': '样式',
        'border-color-sub': '颜色',
        'border-top-left-radius-sub': '左上',
        'border-top-right-radius-sub': '右上',
        'border-bottom-right-radius-sub': '右下',
        'border-bottom-left-radius-sub': '左下',
        'transform-rotate-x': '绕 X 轴旋转',
        'transform-rotate-y': '绕 Y 轴旋转',
        'transform-rotate-z': '绕 Z 轴旋转',
        'transform-scale-x': 'X 轴缩放',
        'transform-scale-y': 'Y 轴缩放',
        'transform-scale-z': 'Z 轴缩放',
        'transition-property-sub': '属性',
        'transition-duration-sub': '时长',
        'transition-timing-function-sub': '缓动',
        'background-image-sub': '图片',
        'background-repeat-sub': '重复',
        'background-position-sub': '位置',
        'background-attachment-sub': '附着',
        'background-size-sub': '尺寸',
        width: '宽度',
        height: '高度',
        margin: '外边距',
        padding: '内边距',
        'font-size': '字体大小',
        'font-family': '字体',
        'font-weight': '字体粗细',
        'letter-spacing': '字间距',
        'line-height': '行高',
        'text-align': '对齐方式',
        color: '颜色',
        'background-color': '背景颜色',
        border: '边框',
        'border-style': '边框样式',
        'border-radius': '边框圆角',
      },
    },
    traitManager: {
      empty: '请先选择元素，再编辑组件设置',
      label: '组件设置',
      traits: {
        attributes: {
          id: {
            placeholder: '例如：这里填写内容',
          },
          alt: {
            placeholder: '例如：这里填写内容',
          },
          title: {
            placeholder: '例如：这里填写内容',
          },
          href: {
            placeholder: '例如：https://www.yzdli.com',
          },
        },
        options: {
          target: {
            false: '当前窗口',
            _blank: '新窗口',
          },
        },
      },
    },
    storageManager: {
      recover: '是否恢复未保存的内容？',
    },
  },
  NEWSLETTER_EDITOR_TEXTS: {
    zh: {
      labelSection: '布局区块',
      labelDivider: '分割线',
      labelButton: '按钮',
      labelText: '文本块',
      labelImage: '图片',
      labelTable: '表格',
      modalTitleImport: '导入 HTML',
      modalTitleExport: '导出 HTML',
      modalLabelImport: '粘贴 HTML',
      modalLabelExport: '复制 HTML',
      modalBtnImport: '导入',
      textCleanCanvas: '确定要清空当前画布吗？',
    },
    en: {
      modalTitleImport: 'Import HTML',
      modalTitleExport: 'Export HTML',
      modalLabelImport: 'Paste HTML',
      modalLabelExport: 'Copy HTML',
      modalBtnImport: 'Import',
      textCleanCanvas: 'Are you sure you want to clear the canvas?',
    },
  },
}
